import { Box, Button, Grid, Stack, Tooltip, Typography } from '@mui/material'
import MicrosoftExcel from 'mdi-material-ui/MicrosoftExcel'
import { useEffect, useState } from 'react'
import { BsFillPersonPlusFill } from "react-icons/bs"
import { Link } from 'react-router-dom'
import { apiService } from '../../api/axiosClient'
import Stat from 'src/components/mui/chip/stat'
import MenuMember from 'src/views/menu/MenuMember'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import { useGetUsersQuery } from '../../store/userApi'
import BoxWrapper from '../../styles/BoxWrapper'
import TableMember from '../../views/member/TableMember'

const MemberList = () => {
  const [reload, setReload] = useState(0)
  const [total, setTotal] = useState(0)
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { data, error } = useGetUsersQuery({
    refetchOnFocus: false
  });

  useEffect(() => {
    data && setTotal(data.data)
  }, [data]);

  const sheetDownload = async () => {
    await apiService.get('/members/excel', {
      responseType: 'blob',
      params: {
        ...filters
      }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "회원리스트.xlsx";
      document.body.appendChild(a);
      a.click();
    }).catch(error => {
      console.error(error)
    });
  }

  return (
    <Page title="Member">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  회원관리
                </Typography>
                <Stat value={total}/>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              고객이 등록한 회원리스트를 보여줍니다.
            </Typography>
          }
        />        
        <BoxWrapper>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <MenuMember setFilters={setFilters} setReload={setReload} />
          </Box>                  
        </BoxWrapper>
        <Stack direction="row" spacing={4} sx={{ mx: 6, py: 3 }}>          
          <Link to="/admin/member/new">
            <Button variant='contained' startIcon={<BsFillPersonPlusFill />} >회원 등록</Button>
          </Link>
          <Tooltip title="모든 등록회원 정보 다운로드">
            <Button variant='contained' color="warning" startIcon={<MicrosoftExcel />} onClick={sheetDownload} >엑셀 다운로드</Button>
          </Tooltip>
        </Stack>
      </Grid>
      <Box sx={{ marginTop: '1rem' }}>
        <TableMember filters={filters} submit={reload} selected={selected} setSelected={setSelected} 
          page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </Box>
    </Page>
  )
}

export default MemberList